import BannerComp from "../components/BannerComp";
import FeatureImageContent from "../components/FeatureImageContent";
import ProPrograms from "../components/ProPrograms";
import ServiceCardsGrid from "../components/ServiceCardsGrid";
import TeamMember from "../components/TeamMember";
import Seo from "../components/Seo";
import { proPrograms } from "../data/about";
import { serviceCards } from "../data/services";
import { teamData } from "../data/teams";
import { createBreadcrumbSchema, createWebPageSchema } from "../lib/seo";
import Section1 from "./Sections/Section1";
import Section2 from "./Sections/Section2";

const seo = {
  title: "About MITSI | MIT4Doctors",
  description:
    "MITSI connects medical technology with top care. It gives providers precise, efficient solutions.",
  schema: [
    createWebPageSchema({
      path: "/about-us",
      title: "About MITSI",
      description:
        "MITSI connects medical technology with top care. It gives providers precise, efficient solutions.",
    }),
    createBreadcrumbSchema("/about-us", "About MITSI"),
  ],
};

export default function About() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/about-us"
        schema={seo.schema}
      />
      <BannerComp
        heading="About MITSI"
        paragraph="MITSI connects medical technology with top care. It gives providers precise, efficient solutions."
        BannerBgImg="/img/banners/about_hero.webp"
        centered
      />
      <Section1 />
      <ProPrograms
        heading="What We Stand For"
        highlightText="Stand For"
        description="We believe in making healthcare better through innovation, technology, and meaningful solutions. Our work is guided by a commitment to better patient care, stronger support for healthcare providers, and improved outcomes for everyone."
        programs={proPrograms}
      />
      <TeamMember
        heading="Meet the Team Behind MITSI"
        highlightWords={["MITSI"]}
        description="Our leadership team brings decades of combined experience in healthcare, technology, and operations to every client we serve."
        members={teamData}
      />

      <ServiceCardsGrid
        sectionTitle="Our Core Services"
        sectionDescription="Explore the main offerings MITSI brings to providers who want a cleaner workflow, stronger support, and a more modern patient experience."
        highlightText="Services"
        cards={serviceCards}
      />

      <FeatureImageContent
        eyebrow="Innovating Healthcare Through"
        heading="Explore Our Advanced Solutions"
        description="Our goal? To transform healthcare with advancements."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Explore Our Advanced Solutions"
      />
      <Section2 />
    </>
  );
}
